import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, Validators, FormControl, AbstractControl } from '@angular/forms';
import { AlertDialogComponent } from 'src/app/shared/alert-dialog/alert-dialog.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataService } from 'src/app/shared/data.service';
import { UtilsService } from 'src/app/shared/utils.service';
import { Router } from '@angular/router';
import { CardBillingComponent } from 'src/app/manufacturer/sponsoring/billing/card-billing/card-billing.component';

declare let paypal: any;

@Component({
    selector: 'app-sign-up',
    templateUrl: './sign-up.component.html',
    styleUrls: ['./sign-up.component.scss'],
    standalone: false
})
export class SignUpComponent implements OnInit {
  signupForm!: FormGroup;
  hide: boolean;
  checkedPrivacyAndTerms: boolean | null;
  showEmailError!: boolean;
  passwordStrength: number;
  meterMessage: string;
  plan: any;
  subscriptionsCount: any;
  subscriptionPrice: any;
  type: any;
  annualFee: any;
  billingForm: any;
  addScript: boolean = false;
  paypalload = false;
  transaction: any = '';
  paypalconfig = {
    env: 'sandbox',
    client: {
      sandbox: 'AfLwhc2UmYN5ZDlvYP1PUWMPvJ76PoQ5m9IBmjkMUJ8pSe9xAuKXY_WwkFVfwPq3gPmeoEEv6Scu-FOe',
      // production: 'AfGW-J6bzgmG72HAUg9T_nEV3fBBuEcSXlXFcKNCmLdxHSWG2It_vYO6EYNlhIGSBkoptFAHS8DmRGZO'
    },
    commit: true,
    payment: (data, actions) => {
      return actions.payment.create({
        payment: {
          transactions: [
            {amount: {total: this.annualFee, currency: 'EUR'}}
          ]
        }
      });
    },
    onError:  (data, actions) => {
    },
    onAuthorize: (data, actions) => {
        const response = actions.payment.execute().then(function(payment) {
          return payment;
        });
          this.transaction = { data, response,
          Type: 1};
          return this.signup();
    },
    style: {
      color: 'black',
      shape: 'rect',
      label: 'checkout',
      tagline: false,
      layout: 'vertical'
    },
    funding:
      {
        disallowed: [ ]
      },
  };
  signupPayload: any;

  constructor(private dialog: MatDialog, private dataService: DataService, private utils: UtilsService, private router: Router,
              public dialogRef: MatDialogRef<SignUpComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any
            ) {
                this.hide = true;
                this.checkedPrivacyAndTerms = null;
                this.meterMessage = '';
                this.passwordStrength = 0;
                this.plan = this.data.plan;
                this.type = this.data.type;
                this.annualFee = this.data.annualFee;
                this.subscriptionsCount = this.data.subscriptionsCount;
                this.subscriptionPrice = this.data.subscriptionPrice;
                if (this.router.currentNavigation() && this.router.currentNavigation()?.extras.state) {
                  const navigateData = this.router.currentNavigation()?.extras.state?.data;
                  this.plan = navigateData.plan;
                  this.annualFee = navigateData.annualFee;
                  this.type = navigateData.type;
                  this.subscriptionsCount = navigateData.subscriptionsCount;
                  this.subscriptionPrice = navigateData.subscriptionPrice;
                }
                if (this.plan === undefined) {
                  this.router.navigate(['/pricing']);
                }
              }

  ngOnInit(): void {
    this.showEmailError = false;
    this.signupForm = new FormGroup({
      password: new FormControl(null, [Validators.required, Validators.pattern(/^(?=.*[a-zA-Z])(?=.*[0-9]).{8,}/)]),
      email: new FormControl(null, [Validators.required, Validators.email, this.utils.isValidEmail.bind(this)]),
      manufacture_name: new FormControl(null, null),
      company_name: new FormControl(null, null),
      account_type: new FormControl({ value: this.type, disabled: true }),
    });
    this.billingForm = new FormGroup({
      annualFee: new FormControl({ value: this.annualFee, disabled: true }),
    });
  }

  ngAfterViewChecked(): void {
    if (!this.addScript) {
      this.addPaypalScript().then(() => {
        // this.paypalconfig.funding = {disallowed: [ paypal.FUNDING.CREDIT ]};
        paypal.Button.render(this.paypalconfig, '#paypal-checkout-btn');
        this.paypalload = true;
      });
    }
  }

  privacyAndTerms(event: any) {
    this.checkedPrivacyAndTerms = event.source.checked;
  }

  onStrengthChanged(strength: number) {
    this.passwordStrength = strength;

    switch (strength) {
      case 0:
      case 1:
        this.meterMessage = 'Weak password';
        break;
      case 2:
        this.meterMessage = 'Fair password';
        break;
      case 3:
        this.meterMessage = 'Normal password';
        break;
      case 4:
        this.meterMessage = 'Strong password';
        break;
      default:
        this.meterMessage = '';
        break;
    }
  }

  accountTypeChange(type: any) {
    if (type === 'manufacture') {
      this.signupForm.controls.manufacture_name.setValidators([Validators.required, this.utils.noWhitespaceValidator.bind(this)]);
      this.signupForm.controls.company_name.setValidators(null);
    } else if (type === 'distrebuter'){
      this.signupForm.controls.company_name.setValidators([Validators.required, this.utils.noWhitespaceValidator.bind(this)]);
      this.signupForm.controls.manufacture_name.setValidators(null);
    }
    this.signupForm.updateValueAndValidity();
  }

  navigateTo(page: any) {
    this.router.navigate([page]);
    this.dialog.closeAll();
  }

  async verifyEmail(): Promise<boolean> {
    const emailControl = this.signupForm.get('email');
    if (!emailControl) return false;

    const payload = { email: emailControl.value };
    try {
      const data: any = await this.dataService.post('auth/ValidateEmail', payload);

      if (data.statusCode === 200) {
        if (data.data.isValid === true) {
          emailControl.setErrors(null);
          this.showEmailError = false;
          if (this.checkedPrivacyAndTerms === null) {
            this.checkedPrivacyAndTerms = false;
          }
          return true;
        } else {
          emailControl.setErrors({ emailUsed: true });
          this.showEmailError = true;
          return false;
        }
      }
    } catch (error) {
      console.error('Email validation failed:', error);
    }
    return false;
  }

  closeDialog() {
    if (this.signupForm.dirty) {
      const dialogRef = this.dialog.open(AlertDialogComponent, {
        disableClose: true,
        width: '400px',
        data: {
          title: 'Warning',
          type: 'Warn',
          message: 'You will miss your information once you close',
          buttonText: 'cancel',
          numberOfButtons: 2,
          seconButtonText: 'Ok'
        }
      });
      dialogRef.afterClosed().subscribe((status) => {
        if (status === 'Ok') {
          this.dialog.closeAll();
        }
      });
    } else {
      this.dialog.closeAll();
    }
  }

  onSubmit(userID: number): any {
    if(this.transaction != ""){
      const payload = {
        Amount: parseInt( this.annualFee , 10),
        Currency: 'EUR',
        Description: 'Buy ' + this.plan + 'plan',
        Count: parseInt(this.subscriptionsCount),
        Token: this.transaction.data.paymentID,
        Type: this.transaction.Type,
        UserId: userID
      };
      this.dataService.post('billing/BillingGateway', payload).then((billingData: any) => {
        if (billingData.statusCode === 200) {
          this.dialog.closeAll();
          const dialogRef = this.dialog.open(AlertDialogComponent, {
            disableClose: true,
            width: '400px',
            data: {
              title: 'Signed Up successfully',
              type: 'Success',
              message: 'You are signed up successfully, please wait for admin approval',
              buttonText: 'Ok'
            }
          });
        } else {
          const dialogRef = this.dialog.open(AlertDialogComponent, {
            disableClose: true,
            width: '400px',
            data: {
              title: 'Error',
              type: 'Error',
              message: 'something went wrong, please try again!',
              buttonText: 'Ok'
            }
          });
        }
      });
    }
  }

  addPaypalScript() {
    this.addScript = true;
    return new Promise((resolve, reject) => {
      const scripttagelement = document.createElement('script');
      scripttagelement.src = 'https://www.paypalobjects.com/api/checkout.js';
      scripttagelement.onload = resolve;
      document.body.appendChild(scripttagelement);
    });
  }

  buyWithCard() {
    const dialogRef = this.dialog.open(CardBillingComponent,
      {disableClose: true, width: '400px', data: {totalAmount: this.annualFee,codesCount: this.subscriptionsCount, plan: this.plan, signup: true}});
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result.status === 'success') {
        var data= {paymentID:result.token}
        this.transaction = { data,
          Type: 2};
        this.signup();
      }
    });
  }

  async signup() {
    if (this.signupForm.valid) {
      const emailOk = await this.verifyEmail(); // waits correctly now
      if (!emailOk) return; // stop if email is already used

      if (this.checkedPrivacyAndTerms) {
        this.signupPayload = {
          planName: this.plan,
          Password: this.signupForm.get('password')?.value,
          Email: this.signupForm.get('email')?.value,
          BusinessName: this.signupForm.get('company_name')?.value ? this.signupForm.get('company_name')?.value : this.signupForm.get('manufacture_name')?.value,
          Type: this.signupForm.get('account_type')?.value === 'distributor' ? 4 : 2
        };
        this.signupPayload.plan = this.plan;
        this.dataService.post('auth/signup', this.signupPayload).then((data: any) => {
          if (data.statusCode === 200) {
            if(this.plan === 'lite' || this.plan === 'free'){
              const dialogRef = this.dialog.open(AlertDialogComponent, {
                disableClose: true,
                width: '400px',
                data: {
                  title: 'Signed Up successfully',
                  type: 'Success',
                  message: 'You are signed up successfully, please wait for admin approval',
                  buttonText: 'Ok'
                }
              });
              this.router.navigate(['/home-script']);
            }
            else {
              this.onSubmit(data.data.id);
            }

          } else if (data.statusCode === 400 || data.statusCode === 600) {
            const dialogRef = this.dialog.open(AlertDialogComponent, {
              disableClose: true,
              width: '400px',
              data: {
                title: 'Error while signing up',
                type: 'Error',
                message: 'Please try again!',
                buttonText: 'Ok'
              }
            });
          }
        });
      }
    } else {
      this.signupForm.markAllAsTouched();
    }
  }
}
